'use client'
import * as React from 'react';

var _path, _path2, _path3, _path4, _g, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SvgWalletClaimHero = function SvgWalletClaimHero(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 112,
    viewBox: "0 0 327 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wallet-claim-hero_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wallet-claim-hero_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 327,
    height: 112
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M315 0H12C5.373 0 0 5.373 0 12v88c0 6.627 5.373 12 12 12h303c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#wallet-claim-hero_svg__b)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164 228c62.96 0 114-51.04 114-114S226.96 0 164 0 50 51.04 50 114s51.04 114 114 114Z",
    fill: "url(#wallet-claim-hero_svg__c)",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("mask", {
    id: "wallet-claim-hero_svg__d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 29,
    width: 40,
    height: 40
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.91 29 86 37.282l8.282 30.91 30.91-8.282L116.91 29Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#wallet-claim-hero_svg__d)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wallet-claim-hero_svg__e",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 33,
    width: 31,
    height: 31
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.763 44.8c-2.097-7.824-10.139-12.467-17.963-10.371-7.824 2.096-12.468 10.139-10.371 17.963 2.096 7.824 10.139 12.467 17.963 10.37 7.824-2.096 12.467-10.138 10.371-17.962Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#wallet-claim-hero_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.709 55.166a14.617 14.617 0 0 0 1.054-10.366c-2.097-7.824-10.139-12.467-17.963-10.371-7.825 2.096-12.468 10.139-10.371 17.963a14.612 14.612 0 0 0 6.097 8.451c1.808-3.916 6.565-6.42 9.647-7.247 3.083-.826 7.955-1.146 11.536 1.57Zm-19.375-8.688a5.5 5.5 0 1 1 10.625-2.848 5.5 5.5 0 0 1-10.625 2.848Z",
    fill: "#4779FF"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m207.67 19.875-.767 2.862a9.86 9.86 0 0 0-5.861 6.61c-1.412 5.269 1.715 10.684 6.984 12.096 5.268 1.412 10.684-1.715 12.096-6.984a9.862 9.862 0 0 0-1.771-8.655l.767-2.861a5.926 5.926 0 0 0-11.448-3.068Zm9.321 2.498-.444 1.655a9.844 9.844 0 0 0-3.409-1.665 9.847 9.847 0 0 0-3.785-.262l.444-1.656a3.723 3.723 0 1 1 7.194 1.928Zm-3.445 8.52a2.57 2.57 0 0 1-2.019 1.862l-.539 2.011a1.1 1.1 0 1 1-2.127-.57l.539-2.01a2.569 2.569 0 1 1 4.146-1.294ZM164.89 32.064a6.223 6.223 0 0 0-1.78 0c-.68.098-1.313.337-1.815.527l-.135.05-16.681 6.256-.406.152c-1.922.718-3.61 1.348-4.91 2.493a9.333 9.333 0 0 0-2.552 3.683c-.616 1.62-.614 3.421-.611 5.473l.001.434V66.01c0 8.793 4.782 16.125 9.952 21.51 5.205 5.422 11.159 9.252 14.308 11.089l.127.075c.575.337 1.321.775 2.307.987a6.624 6.624 0 0 0 2.61 0c.986-.212 1.732-.65 2.307-.987l.127-.075c3.149-1.837 9.103-5.667 14.308-11.088 5.17-5.386 9.952-12.718 9.952-21.511V51.13l.001-.433c.003-2.052.005-3.854-.611-5.473a9.333 9.333 0 0 0-2.552-3.683c-1.3-1.145-2.988-1.775-4.91-2.493-.134-.05-.27-.1-.406-.152l-16.681-6.255-.135-.05c-.502-.19-1.135-.43-1.815-.528Zm-6.946 16.362a9.282 9.282 0 1 1 13.127 13.128 9.282 9.282 0 0 1-13.127-13.128Zm3.282 3.282a4.64 4.64 0 1 1 6.563 6.563 4.64 4.64 0 0 1-6.563-6.563Zm3.515 14.885a11.63 11.63 0 0 1-2.945-.377v15.598h4.641v-4.51h4.601v-4.642h-4.601V66.47a11.69 11.69 0 0 1-1.696.123Z",
    fill: "#4779FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wallet-claim-hero_svg__c",
    x1: 164,
    y1: 0,
    x2: 164,
    y2: 93.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4779FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4779FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "wallet-claim-hero_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h327v112H0z"
  })))));
};

export { SvgWalletClaimHero as ReactComponent };
